export default __webpack_public_path__ + "static/media/two_bottom.c37071fd.png";